import { toast } from "sonner";
import {
  ActionToastContent,
  RealtimeNotificationToastContent,
} from "@/components/common/Notifications/NotificationToasts";

function notifyWithVariant(
  variant,
  message,
  { showClose = true, ...options } = {},
) {
  let id;
  id = toast(
    (toastId) => (
      <ActionToastContent
        message={message}
        showClose={showClose}
        dismiss={() => dismissToast(toastId)}
        variant={variant}
      />
    ),
    {
      ...options,
      duration:
        options.duration ??
        (variant === "error" ? 6000 : variant === "info" ? 5000 : 4000),
      className: "!p-0 !bg-transparent !shadow-none !min-w-0",
    },
  );
  return id;
}
export function notifySuccess(message, options = {}) {
  return notifyWithVariant("success", message, options);
}

export function notifyError(message, options = {}) {
  return notifyWithVariant("error", message, options);
}

export function notifyInfo(message, options = {}) {
  return notifyWithVariant("info", message, options);
}

export function notifyNotification(
  notification,
  { showClose = true, onAction, onMarkRead, ...options } = {},
) {
  if (!notification) return null;

  return toast(
    (toastId) => (
      <RealtimeNotificationToastContent
        notification={notification}
        showClose={showClose}
        dismiss={() => dismissToast(toastId)}
        onAction={onAction}
        onMarkRead={onMarkRead}
      />
    ),
    {
      ...options,
      duration: options.duration ?? 7000,
      className: "!p-0 !bg-transparent !shadow-none !min-w-0",
    },
  );
}

export function dismissToast(id) {
  toast.dismiss(id);
}
